export type TextDirection = 'ltr' | 'rtl' | 'auto';

const RTL_CHAR_RE = /[\u0590-\u08FF\uFB1D-\uFDFD\uFE70-\uFEFC]/u;
const LTR_CHAR_RE = /[A-Za-z\u00C0-\u02AF\u0370-\u052F]/u;
const STRONG_CHAR_RE = /[\u0590-\u08FF\uFB1D-\uFDFD\uFE70-\uFEFCA-Za-z\u00C0-\u02AF\u0370-\u052F]/u;

export const getTextDirection = (value: unknown): TextDirection => {
  const text = String(value ?? '');
  if (!text.trim()) return 'auto';

  for (const char of text) {
    if (!STRONG_CHAR_RE.test(char)) continue;
    if (RTL_CHAR_RE.test(char)) return 'rtl';
    if (LTR_CHAR_RE.test(char)) return 'ltr';
  }

  return 'auto';
};

export const bidiTextStyle = {
  unicodeBidi: 'plaintext',
  textAlign: 'start',
} as const;

export const ltrIsolateStyle = {
  direction: 'ltr',
  unicodeBidi: 'isolate',
  textAlign: 'left',
} as const;

export const getBidiTextProps = (value: unknown) => ({
  dir: getTextDirection(value),
  style: bidiTextStyle,
});

export const muiBidiTextSx = {
  unicodeBidi: 'plaintext',
  textAlign: 'start',
} as const;
